import {
  List,
  Datagrid,
  TextField,
  NumberField,
  Edit,
  SimpleForm,
  TextInput,
  NumberInput,
  Show,
  SimpleShowLayout,
} from 'react-admin'

// <Edit title={<PostTitle />}>
// const PostTitle = () => {
//   const record = useRecordContext()
//   return <span>Post {record ? `'${record.title}'` : ''}</span>
// }

export const ServiceConfigList = ({ isEdit, isDelete }) => (
  <List filters={[]}>
    <Datagrid bulkActionButtons={false} rowClick={isEdit ? 'edit' : 'show'}>
      <TextField source="title" />
      <TextField source="tgAdminChannel" />
      <NumberField source="latestBuildVersion" />
      <NumberField source="minSupportedBuildVersion" />
    </Datagrid>
  </List>
)

export const ServiceConfigEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="tgAdminChannel" />
      <NumberInput source="latestBuildVersion" />
      <NumberInput source="minSupportedBuildVersion" />
    </SimpleForm>
  </Edit>
)

export const ServiceConfigShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="title" />
      <TextField source="tgAdminChannel" />
      <NumberField source="latestBuildVersion" />
      <NumberField source="minSupportedBuildVersion" />
    </SimpleShowLayout>
  </Show>
)
